"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRootSelector = exports.useRootDispatch = exports.useRootSelector = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const react_redux_1 = require("react-redux");
const reducer_1 = require("../reducer");
const persist_1 = __importDefault(require("./persist"));
const preload_1 = __importDefault(require("./preload"));
// Not used anymore
// const store = createStore(rootReducer, preloadState(), composeWithDevTools(applyMiddleware(thunk)))
const newStore = (0, toolkit_1.configureStore)({
    reducer: reducer_1.rootReducer,
    preloadedState: (0, preload_1.default)(),
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
});
newStore.subscribe(() => (0, persist_1.default)(newStore.getState()));
exports.default = newStore;
exports.useRootSelector = react_redux_1.useSelector;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useRootDispatch = () => (0, react_redux_1.useDispatch)();
exports.useRootDispatch = useRootDispatch;
exports.createRootSelector = toolkit_1.createDraftSafeSelector.withTypes();
// In future - https://redux-toolkit.js.org/api/createSlice
